export const META_PIXEL_ID = '3477645812411217'

type FbqFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: FbqFunction
    _fbq?: FbqFunction
  }
}

/**
 * Carga el script de Meta Pixel una sola vez e inicializa el seguimiento
 * con el evento PageView.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.fbq) return

  const fbq: FbqFunction = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args)
    } else {
      fbq.queue?.push(args)
    }
  } as FbqFunction

  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  const noscript = document.createElement('noscript')
  const image = document.createElement('img')
  image.height = 1
  image.width = 1
  image.style.display = 'none'
  image.alt = ''
  image.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(image)
  document.body.appendChild(noscript)

  window.fbq('init', META_PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackPixelEvent(event: string, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, params)
}
